var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChakraUi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.352 0 0 5.352 0 12C0 18.648 5.352 24 12 24C18.648 24 24 18.648 24 12C24 5.352 18.648 0 12 0ZM14.8 4.333C14.93 4.329 15.048 4.469 14.971 4.611L11.927 10.191C11.9116 10.2195 11.9039 10.2514 11.9045 10.2838C11.9051 10.3161 11.9142 10.3477 11.9307 10.3755C11.9472 10.4033 11.9707 10.4264 11.9988 10.4424C12.0269 10.4584 12.0587 10.4669 12.091 10.467H17.351C17.521 10.467 17.603 10.674 17.479 10.79L8.259 19.395C8.094 19.549 7.849 19.332 7.981 19.149L12.345 13.128C12.365 13.1001 12.3769 13.0673 12.3795 13.0331C12.3821 12.9988 12.3752 12.9646 12.3596 12.934C12.344 12.9035 12.3203 12.8778 12.2911 12.8598C12.2619 12.8418 12.2283 12.8322 12.194 12.832H6.627C6.58996 12.8319 6.55378 12.8208 6.52305 12.8001C6.49232 12.7795 6.46843 12.7501 6.45439 12.7158C6.44036 12.6816 6.43682 12.6439 6.44423 12.6076C6.45164 12.5713 6.46966 12.538 6.496 12.512L14.676 4.389C14.7088 4.35477 14.7536 4.33468 14.801 4.333H14.8Z",
    fill: "#4FD1C5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChakraUi);
export default __webpack_public_path__ + "static/media/ChakraUI.965aa67cf983e62a30642a7c9f193b06.svg";
export { ForwardRef as ReactComponent };